/*
  PEACE OUT cart drawer suggestion: "もう1点、合わせるなら".
  Uses Shopify's Product Recommendations API for the newest cart item, skips products
  already in the cart, shows up to N cards. Each card: pick a size (defaults to the size
  of that cart item when available), then "+ M でカートに追加". No discount.
  The cart drawer re-renders its HTML after every change, so this element simply
  reloads when it is created again.
*/
if (!customElements.get('po-cart-upsell')) {
  customElements.define(
    'po-cart-upsell',
    class PoCartUpsell extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded) return;
        this.dataset.loaded = 'true';
        this.load();
      }

      async load() {
        const productId = this.dataset.productId;
        if (!productId) return;
        const limit = parseInt(this.dataset.limit, 10) || 2;
        const exclude = (this.dataset.exclude || '').split(',').filter(Boolean);
        const url = `${this.dataset.url}?product_id=${productId}&limit=10&intent=related&section_id=po-cart-upsell-items`;
        let html = '';
        try {
          const res = await fetch(url);
          if (!res.ok) return;
          html = await res.text();
        } catch (e) {
          return; // No suggestion is fine; the cart keeps working.
        }
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const cards = Array.from(doc.querySelectorAll('[data-po-upsell-card]'))
          .filter((card) => !exclude.includes(card.dataset.productId))
          .slice(0, limit);
        if (cards.length === 0) return;

        const grid = this.querySelector('[data-po-upsell-grid]');
        cards.forEach((card) => {
          grid.appendChild(card);
          this.setupCard(card);
        });
        this.hidden = false;
      }

      setupCard(card) {
        let variants = [];
        try {
          variants = JSON.parse(card.querySelector('[data-po-upsell-variants]').textContent);
        } catch (e) {
          return;
        }
        const sizeButtons = Array.from(card.querySelectorAll('[data-po-size]'));
        const addButton = card.querySelector('[data-po-upsell-add]');
        const error = card.querySelector('[data-po-upsell-error]');
        const preferred = this.dataset.size || '';
        let selectedSize = null;

        const firstAvailable = (size) => variants.find((v) => v.available && (size === null || v.size === size));

        sizeButtons.forEach((button) => {
          const size = button.dataset.poSize;
          if (!firstAvailable(size)) button.disabled = true;
          button.addEventListener('click', () => {
            selectedSize = size;
            render();
          });
        });

        if (sizeButtons.length) {
          const preferredOk = sizeButtons.find((b) => b.dataset.poSize === preferred && !b.disabled);
          const firstOk = sizeButtons.find((b) => !b.disabled);
          selectedSize = (preferredOk || firstOk || {}).dataset?.poSize || null;
        }

        const render = () => {
          sizeButtons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.poSize === selectedSize)));
          const variant = sizeButtons.length ? firstAvailable(selectedSize) : firstAvailable(null);
          addButton.disabled = !variant || addButton.classList.contains('is-busy');
          if (!addButton.classList.contains('is-added')) {
            addButton.textContent = selectedSize ? `+ ${selectedSize} でカートに追加` : '+ カートに追加';
          }
        };

        addButton.addEventListener('click', async () => {
          const variant = sizeButtons.length ? firstAvailable(selectedSize) : firstAvailable(null);
          if (!variant || addButton.classList.contains('is-busy')) return;
          addButton.classList.add('is-busy');
          addButton.disabled = true;
          error.hidden = true;
          try {
            const res = await fetch(`${window.routes.cart_add_url}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [{ id: variant.id, quantity: 1 }],
                sections: 'cart-drawer,cart-icon-bubble',
                sections_url: window.location.pathname,
              }),
            });
            const state = await res.json();
            if (!res.ok || state.status) throw new Error(state.description || state.message || 'error');
            addButton.classList.remove('is-busy');
            addButton.classList.add('is-added');
            addButton.textContent = '追加済み ✓';
            const drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.renderContents === 'function') {
              drawer.renderContents(state);
            }
          } catch (e) {
            addButton.classList.remove('is-busy');
            error.textContent = '追加できませんでした。もう一度お試しください。';
            error.hidden = false;
            render();
          }
        });

        render();
      }
    }
  );
}
